import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Layout,
  message,
  Modal,
  Popconfirm,
  Popover,
  Select,
  Table,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";

import {
  ContragentAutocomplete,
  NomenclatureAutoComplete,
  OrganizationAutoComplete,
  WareHousesAutocomplete,
} from "src/shared";

import {
  CloseOutlined,
  DeleteOutlined,
  DollarOutlined,
  PlusOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import Compact from "antd/es/space/Compact";
import axios from "axios";
import BarcodeReader from "react-barcode-reader";
import { DocSalesDrawer } from "src/enitities/Form";
import { apiRequests } from "src/shared/api/api";
import NomenclatureSearchField from "src/shared/api/NomenclatureSearchField";
import { AddBarCode } from "..";
import PayboxAutocomplete from "../../../shared/api/PayboxAutocomplete";

const { Header, Sider, Content } = Layout;

export const searchResult = async (api, token, query, ts) => {
  let type = ts ? "barcode" : "name";
  return fetch(`${api}nomenclature/?token=${token}&${type}=${query}`)
    .then((response) => response.json())
    .then((body) =>
      body.result.map((user) => ({
        label: `${user.name}`,
        value: user.id,
      }))
    );
};

const headerStyle = {
  textAlign: "center",
  color: "#fff",
  height: 35,
  backgroundColor: "white",
  width: "100%",
  padding: "0",
};

const contentStyle = {
  textAlign: "center",
  lineHeight: "120px",
  color: "#fff",
  backgroundColor: "white",
};

const siderStyle = {
  textAlign: "center",
  backgroundColor: "white",
};

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    console.log(dataIndex);
    if (editing) {
      inputRef.current.focus();
    }
    // eslint-disable-next-line
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const calculateSum = () => {
    const valueInput = form.getFieldValue(dataIndex);
    let sum = Number(record.amount) * (Number(valueInput) / 100);
    form.setFieldValue(dataIndex, sum.toFixed(2));
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  const handleBlur = (e) => {
    if (e.relatedTarget.type === "button") {
      calculateSum();
      save();
    } else {
      save();
    }
  };

  let childNode = children;
  let ed = editing ? (
    <Form.Item
      style={{
        margin: 0,
      }}
      name={dataIndex}
      rules={[
        {
          required: dataIndex !== "amount",
          message: `${title} обязательно для ввода.`,
        },
      ]}
    >
      <Input
        ref={inputRef}
        addonAfter={
          dataIndex === "discount" ? (
            <Button type={"text"} size={"small"} icon={<DollarOutlined />} />
          ) : null
        }
        onPressEnter={save}
        onBlur={handleBlur}
      />
    </Form.Item>
  ) : (
    <div
      className="editable-cell-value-wrap"
      style={{
        paddingRight: 24,
      }}
      onClick={toggleEdit}
    >
      {children}
    </div>
  );

  if (editable) {
    if (record.type !== "transfer") {
      childNode = ed;
    } else {
      if (dataIndex === "tax") {
        childNode = null;
      } else {
        childNode = ed;
      }
    }
  }

  return <td {...restProps}>{childNode}</td>;
};

class NewDocsSales extends React.Component {
  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.formRefSettings = React.createRef();
    this.formRefNom = React.createRef();
    this.finRef = React.createRef();
    this.confirm = Modal.confirm;

    this.state = {
      isModalVisible: false,
      changeData: false,
      current_warehouse: null,
      current_contragent: null,
      current_paybox: null,
      discount_type: "percent",
      loyality_balance: null,
      nomenclature_min: 0,
      nomenclature_max: 0,
      amount_without_discount: 0,
      amount_with_discount: 0,
      amount_discount: 0,
      nomDS: [],
      isRequestLoading: false,
      current_nomenclature_price: null,
      nomId: null,
      isAddBarCodeVisible: false,
      barcode: null,
      rentAdd: false,
      settings: {},
    };
    this.api = `https://${process.env.REACT_APP_APP_URL}/api/v1/`;

    this.columns = [
      {
        title: "Название товара",
        key: "name",
        dataIndex: "name",
      },
      {
        title: "Сумма",
        key: "amount",
        dataIndex: "amount",
        editable: true,
      },
      {
        title: "Скидка",
        key: "discount",
        dataIndex: "discount",
        editable: true,
      },
      {
        title: "Количество",
        key: "count",
        dataIndex: "count",
        editable: true,
      },
      {
        title: "Единица",
        key: "unit",
        dataIndex: "unit",
      },
      {
        title: "Итого",
        key: "final_amount",
        dataIndex: "final_amount",
      },
      {
        title: "Действие",
        key: "action",
        dataIndex: "action",
        render: (_, record) => {
          return (
            <Popconfirm
              title="Подтвердите удаление"
              onConfirm={() => this.handleDeleteNom(record.id)}
              cancelText="Отмена"
              okText="OK"
            >
              <Button icon={<DeleteOutlined />} style={{ marginRight: 10 }} />
            </Popconfirm>
          );
        },
      },
    ];
  }

  closeAddBarcode = () => {
    this.setState({ isAddBarCodeVisible: false, barcode: null });
  };

  barcodeFind = async (data) => {
    const res = await searchResult(this.api, this.props.token, data, true);
    if (!res[0]) {
      this.setState({ isAddBarCodeVisible: true, barcode: data });
    } else {
      this.onSelectNom(res[0].value);
    }
    console.log(res);
  };

  findContragent = async (id) => {
    return fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/contragents/${id}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then((body) => {
        return body;
      });
  };

  findPayboxes = async (id) => {
    return fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/payboxes/${id}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then((body) => {
        return body;
      });
  };

  raschet = (nomDS) => {
    let sum_without_d = 0;
    let sum_with_d = 0;
    let sum_of_d = 0;

    nomDS.map((item) => {
      let discount = parseFloat(item.discount);
      let count = parseInt(item.count);
      let amount = parseFloat(item.amount);
      let final_amount = parseFloat(item.final_amount);

      sum_with_d += final_amount;
      sum_of_d += discount;
      sum_without_d += count * amount;
      return 1;
    });
    const amountWithoutDiscount = parseFloat(sum_without_d).toFixed(2);
    const amountDiscount = parseFloat(sum_of_d).toFixed(2);
    const amountWithDiscount = parseFloat(sum_with_d).toFixed(2);
    this.setFinishPrices(amountWithDiscount);
    this.setState({
      amount_without_discount: amountWithoutDiscount,
      amount_discount: amountDiscount,
      amount_with_discount: amountWithDiscount,
    });
  };

  handleSave = (row) => {
    const newData = [...this.state.nomDS];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];

    row.amount = parseFloat(row.amount).toFixed(2);
    row.discount = parseFloat(row.discount).toFixed(2);
    row.count = parseFloat(row.count).toFixed(3);
    row.final_amount = parseFloat(row.amount * row.count).toFixed(2);

    if (row.discount > 0) {
      row.final_amount = parseFloat(row.final_amount - row.discount).toFixed(2);
    }

    newData.splice(index, 1, { ...item, ...row });

    this.setState(
      {
        nomDS: newData,
      },
      () => this.raschet(newData)
    );

    // this.edit_request(newData.splice(index, 1, { ...item, ...row })[0]);
  };

  onSelectCa = (val) => {
    if (!val) {
      this.formRef.current.setFieldsValue({
        contragent: val,
      });
      return this.setState({ current_contragent: null });
    }
    this.findContragent(val).then((res) => {
      this.setState({ current_contragent: res });
      this.formRef.current.setFieldsValue({
        contragent: res.name,
      });
      fetch(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/loyality_cards/?token=${this.props.token}&phone_number=${res.phone}`
      )
        .then((response) => response.json())
        .then((body) => {
          if (body.result.length === 0) {
            this.setState({
              loyality_balance: "Нет карты",
              loyality_card: null,
            });
          } else {
            const loyalityBalance = body.result[0].balance.toFixed(2);
            const loyalityCard = body.result[0];
            this.setState(
              {
                loyality_balance: loyalityBalance,
                loyality_card: loyalityCard,
              },
              () => this.setFinishPrices(this.state.amount_with_discount)
            );
          }
        })
        .catch((err) => {
          this.setState(
            {
              loyality_balance: "Нет карты",
              loyality_card: null,
            },
            () => this.setFinishPrices(this.state.amount_with_discount)
          );
        });
    });
  };

  findContract = async (id) => {
    return fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/contracts/${id}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then((body) => {
        return body;
      });
  };

  onSelectContract = (val) => {
    this.findContract(val).then((res) => {
      this.setState({ current_contract: res });
      this.formRef.current.setFieldsValue({
        contract: res.name,
      });
    });
  };

  onSelectPaybox = (val) => {
    this.findPayboxes(val).then((res) => {
      this.setState({ current_paybox: res });
      this.formRef.current.setFieldsValue({
        paybox: res.name,
      });
    });
  };

  findOrg = async (id) => {
    return fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/organizations/${id}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then((body) => {
        return body;
      });
  };

  onSelectOrg = (val) => {
    this.findOrg(val).then((res) => {
      this.setState({ current_organization: res });
      this.formRef.current.setFieldsValue({
        organization: res.short_name,
      });
    });
  };

  findWareHouse = async (id = "") => {
    return fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/warehouses/${id}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then((body) => {
        return body;
      });
  };

  onSelectWareHouse = (val) => {
    this.findWareHouse(val).then((res) => {
      this.setState({ current_warehouse: res }, () => {
        this.formRef.current.setFieldsValue({
          warehouse: res.name,
        });

        if (
          this.props.rent_nomenclature &&
          this.state.current_warehouse &&
          !this.state.rentAdd
        ) {
          this.onSelectNom(this.props.rent_nomenclature);
          this.setState({ rentAdd: true });
        }
      });
    });
  };

  findNomenclature = async (id) => {
    return fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/nomenclature/${id}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then((body) => {
        return body;
      });
  };

  handleDeleteNom = (id) => {
    const newData = [...this.state.nomDS];
    const index = newData.findIndex((item) => id === item.id);

    if (index !== -1) {
      newData.splice(index, 1);
      this.setState(
        {
          nomDS: newData,
        },
        () => this.raschet(newData)
      );
    }
  };

  // onSelectNom = (val) => {
  //   this.setState({ current_nomenclature_price: null });
  //   this.findNomenclature(val).then((res) => {
  //     this.setState({ current_nomenclature: res });
  //     this.formRefNom.current.setFieldsValue({
  //       nomenclature: res.name,
  //     });

  //     if (res.type === "product") {
  //       if (!this.state.current_warehouse) {
  //         message.error("Вы не выбрали склад!");
  //       } else {
  //         fetch(
  //           `https://${process.env.REACT_APP_APP_URL}/api/v1/warehouse_balances/${this.state.current_warehouse.id}?token=${this.props.token}&nomenclature_id=${res.id}`
  //         )
  //           .then((response) => response.json())
  //           .then((body) => {
  //             if (body > 0) {
  //               this.formRefNom.current.setFieldsValue({
  //                 count: 1,
  //               });
  //               this.setState({
  //                 nomenclature_min: 1,
  //                 nomenclature_max: body,
  //                 addNomButtonDisabled: false,
  //               });
  //             } else {
  //               this.formRefNom.current.setFieldsValue({
  //                 count: 0,
  //               });
  //               this.setState({
  //                 nomenclature_min: 0,
  //                 nomenclature_max: 0,
  //                 addNomButtonDisabled: false,
  //               });
  //             }
  //           });
  //       }
  //     } else {
  //       this.formRefNom.current.setFieldsValue({
  //         count: 1,
  //       });
  //       this.setState({
  //         nomenclature_min: 1,
  //         nomenclature_max: null,
  //         addNomButtonDisabled: false,
  //       });
  //     }

  //     axios
  //       .get(
  //         `https://${process.env.REACT_APP_APP_URL}/api/v1/alt_prices/${res.id}/`,
  //         { params: { token: this.props.token } }
  //       )
  //       .then((response) => {
  //         this.setState({ current_nomenclature_price: response.data.price });
  //       });
  //   });
  // };

  onSelectNom = (val) => {
    this.setState({ current_nomenclature_price: null });
    this.findNomenclature(val).then((res) => {
      this.setState({ current_nomenclature: res });
      this.setState({ nomId: res.id });
      this.formRefNom.current.setFieldsValue({
        nomenclature: res.name,
        chosen_nomenclature: res.name,
      });

      if (res.type === "product") {
        if (!this.state.current_warehouse) {
          message.error("Вы не выбрали склад!");
        } else {
          fetch(
            `https://${process.env.REACT_APP_APP_URL}/api/v1/alt_warehouse_balances/?token=${this.props.token}&nomenclature_id=${res.id}&warehouse_id=${this.state.current_warehouse.id}`
          )
            .then((response) => response.json())
            .then((body) => {
              if (body.result.length > 0) {
                this.formRefNom.current.setFieldsValue({
                  count: 1,
                });
                console.log(body.result.current_amount);
                this.setState(
                  {
                    nomenclature_min: 1,
                    nomenclature_max: body.result[0].current_amount,
                    addNomButtonDisabled: false,
                  },
                  () => this.setFinishPrices(this.state.amount_with_discount)
                );
              } else {
                this.formRefNom.current.setFieldsValue({
                  count: 0,
                });
                this.setState(
                  {
                    nomenclature_min: 0,
                    nomenclature_max: 0,
                    addNomButtonDisabled: false,
                  },
                  () => this.setFinishPrices(this.state.amount_with_discount)
                );
              }
            });
        }
      } else {
        this.formRefNom.current.setFieldsValue({
          count: 1,
        });
        this.setState(
          {
            nomenclature_min: 1,
            nomenclature_max: null,
            addNomButtonDisabled: false,
          },
          () => this.setFinishPrices(this.state.amount_with_discount)
        );
      }

      axios
        .get(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/alt_prices/${res.id}/`,
          {
            params: { token: this.props.token },
          }
        )
        .then((response) => {
          this.setState((prev) => ({
            ...prev,
            current_nomenclature_price: response.data.price,
          }));
        })
        .catch((err) => this.setState({ current_nomenclature_price: null }));

      this.setState({ nomId: res.id }, () => {
        if (this.formRefNom.current) {
          this.formRefNom.current.submit();
        }
      });
    });
  };

  changeCount = (val) => {
    let value = this.formRefNom.current.getFieldValue("count");
    let nextVal = 0;

    if (val === "plus") {
      nextVal = value + 1;
    } else {
      nextVal = value - 1;
    }

    //if (nextVal >= this.state.nomenclature_min && nextVal <= this.state.nomenclature_max) {
    if (nextVal >= 0) {
      this.formRefNom.current.setFieldValue("count", nextVal);
    }
  };

  changeDiscount = (val) => {
    if (val === "percent") {
      this.setState({ discount_type: "percent" });
    }

    if (val === "rubles") {
      this.setState({ discount_type: "rubles" });
    }
  };

  addNomenclature = async (values) => {
    this.setState({ isRequestLoading: true });
    fetch(
      `https://${process.env.REACT_APP_APP_URL}/api/v1/alt_prices/${this.state.nomId}/?token=${this.props.token}`
    )
      .then((response) => response.json())
      .then(async (body) => {
        this.setState({ isRequestLoading: false });
        const count = parseFloat(values.count);
        const amount = body.price ? body.price : 0;
        let item = {
          id: this.state.current_nomenclature.id,
          name: values.nomenclature,
          amount: this.state.current_nomenclature_price?.toFixed(2) || 0,
          discount: 0,
          count: 1,
          unit: this.state.current_nomenclature.unit_name,
          final_amount: (amount * count).toFixed(2),
        };

        if (values.discount > 0) {
          if (this.state.discount_type === "percent") {
            const amount = parseFloat(item.amount);
            const onePerc = amount / 100;
            const discount = onePerc * values.discount;

            item.discount = discount.toFixed(2);
            item.final_amount = (item.final_amount - item.discount).toFixed(2);
          } else {
            item.discount = values.discount.toFixed(2);
            item.final_amount = (item.final_amount - item.discount).toFixed(2);
          }
        }

        const DS = [...this.state.nomDS];
        const index = DS.findIndex(
          (item) => this.state.current_nomenclature.id === item.id
        );
        console.log(DS);

        if (index !== -1) {
          const item = DS[index];
          //if (item.count < this.state.nomenclature_max) {
          item.count = parseInt(item.count + values.count);
          const itemCount = parseFloat(item.count);
          const itemAmount = parseFloat(item.amount);
          const itemDiscount = parseFloat(item.discount);

          item.final_amount = (itemCount * itemAmount - itemDiscount).toFixed(
            2
          );
          this.setState({ nomDS: DS, isRequestLoading: false }, () =>
            this.raschet(DS)
          );
          //}
          //else {
          //    message.error("На складе нет такого количества")
          //}
        } else {
          DS.unshift(item);
          this.setState({ nomDS: DS, isRequestLoading: false }, () =>
            this.raschet(DS)
          );
        }
      })
      .catch((e) => {
        this.setState({ isRequestLoading: false });
      })
      .finally(() => {
        console.log("4", this.state.isRequestLoading);
      });
  };

  finish = (action) => {
    const { nomDS, date_next_created } = this.state;

    let body = {
      number: this.formRef.current.getFieldValue("number"),
      dated: Math.floor(Date.now() / 1000),
      operation: "Заказ",
      comment: this.formRef.current.getFieldValue("comment"),
      tax_included: true,
      tax_active: true,
      goods: [],
      settings: {
        ...this.formRefSettings.current?.getFieldsValue([
          "repeatability_period",
          "repeatability_value",
          "repeatability_count",
          "transfer_from_weekends",
          "skip_current_month",
          "default_payment_status",
          "repeatability_tags",
          "date_next_created",
          "repeatability_status",
        ]),
        date_next_created: date_next_created,
      },
    };

    if (this.props.tags !== undefined) {
      body.tags = this.props.tags;
    }

    if (this.state.loyality_card) {
      body.loyality_card_id = this.state.loyality_card.id;
    }

    if (!this.state.current_warehouse || !this.state.current_organization) {
      message.error("Вы не выбрали склад или организацию!");
    } else {
      body.warehouse = this.state.current_warehouse.id;

      if (this.state.current_contragent) {
        if (this.state.current_contragent.contragent) {
          body.contragent = this.state.current_contragent.contragent;
        } else {
          body.contragent = this.state.current_contragent.id;
        }
      }
      if (this.state.current_contract) {
        body.contract = this.state.current_contract.id;
      }
      if (this.state.current_paybox) {
        body.paybox = this.state.current_paybox.id;
      }
      if (this.state.current_organization) {
        body.organization = this.state.current_organization.id;
      }

      nomDS.map((item) => {
        let good_body = {
          price: parseFloat(item.amount),
          quantity: parseFloat(item.count),
          unit: 116,
          discount: parseFloat(item.discount),
          sum_discounted: parseFloat(item.discount),
          nomenclature: item.id,
        };
        body.goods.push(good_body);
        return 0;
      });

      if (action === "add_proc") {
        body.status = true;
        body.paid_rubles = this.finRef.current.getFieldValue("rubles") || 0;
        body.paid_lt = this.finRef.current.getFieldValue("lt") || 0;
        body.sum = body.paid_rubles + body.paid_lt;
      } else if (action === "only_add") {
        body.status = false;
        body.paid_rubles = this.finRef.current.getFieldValue("rubles");
        body.paid_lt = this.finRef.current.getFieldValue("lt");
      }
      this.setState({ isRequestLoading: true });

      apiRequests.docs
        .postSales([body])
        .then((response) => {
          message.success("Вы успешно создали документ");
          if (this.props.onSave) {
            this.props.onSave(response.data[0]);
          }
          this.handleState();
        })
        .catch((e) => {
          message.error("Ошибка, пожалуйста повторите позже");
          console.log(e);
          this.setState({ isRequestLoading: false });
        });
    }
  };

  setFinishPrices = (total) => {
    // if (this.state.loyality_card) {
    //   const loyalityBalance = this.state.loyality_card.balance;
    //   const maxDiscount = this.state.loyality_card.max_percentage;
    //   const availableDiscount = (loyalityBalance / 100) * maxDiscount;
    //   const rublesWithDiscount = total - availableDiscount;
    //   if (rublesWithDiscount <= 0) {
    //     const rubles = 0;
    //     const loyality = availableDiscount + rublesWithDiscount;
    //     this.finRef.current.setFieldValue("lt", loyality);
    //     this.finRef.current.setFieldValue("rubles", rubles);
    //     this.setState({
    //       max_paid_loyality: availableDiscount,
    //     });
    //     return null;
    //   }
    //   this.finRef.current.setFieldValue("lt", availableDiscount);
    //   this.finRef.current.setFieldValue("rubles", rublesWithDiscount);
    //   this.setState({
    //     max_paid_loyality: availableDiscount,
    //   });
    //
    //
    // }
    if (this.state.loyality_card) {
      const loyalityBalance = this.state.loyality_card.balance;
      const maxDiscount = this.state.loyality_card.max_withdraw_percentage;
      const availableDiscount = (total / 100) * maxDiscount;
      console.log(total, loyalityBalance);
      if (loyalityBalance <= availableDiscount) {
        const rubles = total - loyalityBalance;
        this.finRef.current.setFieldValue("lt", loyalityBalance);
        this.finRef.current.setFieldValue("rubles", rubles);
        this.setState({ max_paid_loyality: loyalityBalance });
        return null;
      }
      const rublesWithDiscount = total - availableDiscount;
      this.finRef.current.setFieldValue("lt", availableDiscount);
      this.finRef.current.setFieldValue("rubles", rublesWithDiscount);
      this.setState({ max_paid_loyality: availableDiscount });
    } else {
      this.finRef.current.setFieldValue("lt", 0.0);
      this.finRef.current.setFieldValue("rubles", total);
      this.setState({ max_paid_loyality: 0 });
    }
  };

  onRecalculateLoyality = (value) => {
    if (this.state.loyality_card) {
      const total = this.state.amount_without_discount;
      const diff = Math.abs(total - value);
      this.finRef.current.setFieldValue("lt", diff);
    }
  };

  onRecalculateRubles = (value) => {
    const total = this.state.amount_without_discount;
    const diff = Math.abs(total - value);
    this.finRef.current.setFieldValue("rubles", diff);
  };

  handleState = () => {
    this.setState({
      isModalVisible: false,
      changeData: false,
      current_warehouse: null,
      current_contragent: null,
      current_paybox: null,
      discount_type: "percent",
      loyality_balance: 0,
      nomenclature_min: 0,
      nomenclature_max: 0,
      amount_without_discount: 0,
      amount_with_discount: 0,
      amount_discount: 0,
      nomDS: [],
      loyality_card: null,
      isRequestLoading: false,
      current_nomenclature_price: null,
      date_next_created: null,
      rentAdd: false,
    });
  };

  handleCancel = () => {
    this.state.changeData === true
      ? Modal.confirm({
          title: "Подтвердите действие",
          content: "Вы дейтвительно хотите закрыть окно?",
          okText: "Да",
          cancelText: "Нет",
          onOk: () => {
            this.handleState();
          },
        })
      : this.handleState();
  };

  createLoyalityCard = async () => {
    this.props.messageApi.open({
      key: "cards_request",
      type: "loading",
      content: "Ожидайте...",
    });
    await apiRequests.loyalitySettings
      .getItems({
        token: this.props.token,
        organization_id: this.state.current_organization.id,
      })
      .then((res) => {
        if (res.data.result.length === 0) {
          this.props.messageApi.open({
            key: "cards_request",
            type: "info",
            // eslint-disable-next-line
            content: (
              <span>
                Возможно у вас нету{" "}
                <a
                  target={"_blank"}
                  rel="noreferrer" //добавил чтобы запушилось
                  href={`/loyality_settings?token=${this.props.token}`}
                >
                  настроек карты лояльности
                </a>
              </span>
            ),
            duration: 5,
          });
        } else {
          return res.data.result[0];
        }
      })
      .then((organization) => {
        const body = {
          card_number: this.state.current_contragent.phone,
          tags: "",
          phone_number: this.state.current_contragent.phone,
          contragent_id: this.state.current_contragent.id,
          contragent_name: this.state.current_contragent.name,
          organization_id: this.state.current_organization.id,
          lifetime: organization.lifetime,
          status_card: true,
          is_deleted: false,
        };
        apiRequests.loyalityCards
          .post([body])
          .then((res) => {
            return res.data[0].id;
          })
          .then((cardId) => {
            apiRequests.loyalityCards.getById(cardId).then((res) => {
              const loyalityBalance = res.data.balance.toFixed(2);
              this.setState(
                {
                  loyality_balance: loyalityBalance,
                  loyality_card: res.data,
                },
                () => {
                  this.props.messageApi.open({
                    key: "cards_request",
                    type: "success",
                    content: "Карта успешно создана",
                    duration: 5,
                  });
                  this.setFinishPrices(this.state.amount_with_discount);
                }
              );
            });
          });
      });

    console.log(this.state.current_contragent);
    console.log(this.state.current_organization);
  };

  onValuesChange = (changedValues, allValues) => {
    this.setState({ changeData: true });
  };

  render() {
    const showModal = () => {
      this.setState({ isModalVisible: true });

      // Поищем контрагента по номеру
      if (this.props.phone !== undefined) {
        fetch(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/contragents/?token=${this.props.token}&limit=1000&offset=0&phone=${this.props.phone}`
        )
          .then((res) => res.json())
          .then((response) => {
            if (response.result.length > 0) {
              this.onSelectCa(response.result[0].id);
            } else {
              // Создадим нового
              let body = {
                name: this.props.name,
                phone: this.props.phone,
              };
              apiRequests.contragents.post(body).then((response) => {
                this.onSelectCa(response.data.id);
              });
            }
          });
      }
    };

    const { nomDS } = this.state;
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <>
        <Button
          style={{ marginBottom: 15 }}
          icon={<PlusOutlined />}
          type="primary"
          onClick={showModal}
        >
          Новая продажа
        </Button>
        <Modal
          width={1800}
          centered
          ref={this.modalRef}
          destroyOnClose={true}
          footer={null}
          title={[
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              Проведение документа продажи
              <Button.Group>
                <Popover
                  title="Настройки"
                  trigger="click"
                  content={
                    <Form
                      name="basic"
                      ref={this.formRefSettings}
                      onValuesChange={this.onValuesChange}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "4px",
                        }}
                      >
                        <Form.Item
                          name="repeatability_period"
                          style={{ flex: 2 }}
                        >
                          <Select
                            placeholder="Период"
                            options={[
                              { value: "minutes", label: "Минуты" },
                              { value: "hours", label: "Часы" },
                              { value: "days", label: "Дни" },
                              { value: "weeks", label: "Недели" },
                              { value: "months", label: "Месяцы" },
                            ]}
                          />
                        </Form.Item>
                        <Form.Item
                          name="repeatability_value"
                          style={{ flex: 1 }}
                        >
                          <Input type="number" placeholder="value" />
                        </Form.Item>
                        <Form.Item
                          name="repeatability_count"
                          style={{ flex: 1 }}
                        >
                          <Input type="number" placeholder="count" />
                        </Form.Item>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ textAlign: "end" }}>
                            <Form.Item
                              label="Переносить с выходных"
                              name="transfer_from_weekends"
                              style={{ margin: 0 }}
                              valuePropName="checked"
                            >
                              <Checkbox defaultChecked />
                            </Form.Item>
                            <Form.Item
                              label="Пропустить текущий месяц"
                              name="skip_current_month"
                              valuePropName="checked"
                              style={{ margin: 0 }}
                            >
                              <Checkbox defaultChecked />
                            </Form.Item>
                          </div>
                          <div style={{ textAlign: "end" }}>
                            <Form.Item
                              label="Проводить платежи"
                              name="default_payment_status"
                              valuePropName="checked"
                              style={{ margin: 0 }}
                            >
                              <Checkbox />
                            </Form.Item>
                            <Form.Item
                              label="Повторить теги"
                              name="repeatability_tags"
                              valuePropName="checked"
                              style={{ margin: 0 }}
                            >
                              <Checkbox />
                            </Form.Item>
                          </div>
                        </div>
                        <Form.Item
                          label="Включить автоповтор"
                          name="repeatability_status"
                          style={{ margin: "24px 0 0 0" }}
                          valuePropName="checked"
                        >
                          <Checkbox defaultChecked />
                        </Form.Item>
                        <Form.Item
                          name="date_next_created"
                          style={{ margin: "24px 0 0 0" }}
                        >
                          <DatePicker
                            style={{ width: "100%" }}
                            placeholder="Следующее создание"
                            onChange={(date) =>
                              this.setState({ date_next_created: date.unix() })
                            }
                          />
                        </Form.Item>
                      </div>
                    </Form>
                  }
                >
                  <Button>
                    <SettingOutlined />
                  </Button>
                </Popover>
                <Button onClick={this.handleCancel}>
                  <CloseOutlined />
                </Button>
              </Button.Group>
            </div>,
          ]}
          closeIcon={null}
          open={this.state.isModalVisible}
          onCancel={this.handleCancel}
        >
          <AddBarCode
            visible={this.state.isAddBarCodeVisible}
            close={this.closeAddBarcode}
            barcode={this.state.barcode}
            api={this.api}
            token={this.props.token}
          />
          <BarcodeReader onScan={this.barcodeFind} />
          <Layout
            style={{
              pointerEvents: `${
                this.state.isRequestLoading === true ? "none" : ""
              }`,
            }}
          >
            <Sider style={siderStyle}>
              <Form
                name="basic"
                ref={this.formRef}
                onValuesChange={this.onValuesChange}
                layout="vertical"
                style={{ marginLeft: 10, marginRight: 10 }}
                initialValues={{
                  remember: true,
                }}
                // onFinish={onFinish}
              >
                <Form.Item
                  label="Контрагент"
                  name="contragent"
                  style={{ marginBottom: 12 }}
                >
                  <ContragentAutocomplete
                    forType={"docs_sales"}
                    contragent={this.state.current_contragent}
                    width={180}
                    api={this.api}
                    token={this.props.token}
                    onSelect={this.onSelectCa}
                  />
                </Form.Item>

                <Form.Item
                  label="Счет поступления"
                  name="paybox"
                  style={{ marginBottom: 12 }}
                >
                  <PayboxAutocomplete
                    api={this.api}
                    token={this.props.token}
                    onSelect={this.onSelectPaybox}
                  />
                </Form.Item>

                <Form.Item
                  label="Склад отгрузки"
                  name="warehouse"
                  style={{ marginBottom: 12 }}
                >
                  <WareHousesAutocomplete
                    api={this.api}
                    token={this.props.token}
                    onSelect={this.onSelectWareHouse}
                    nodefaultvalue={true}
                  />
                </Form.Item>

                <Form.Item label="Организация" name="organization">
                  <OrganizationAutoComplete
                    api={this.api}
                    token={this.props.token}
                    onSelect={this.onSelectOrg}
                    nodefaultvalue={true}
                  />
                </Form.Item>

                <DocSalesDrawer
                  onSelectContract={this.onSelectContract}
                  token={this.props.token}
                />
              </Form>
            </Sider>
            <Layout>
              <Header style={headerStyle}>
                <Form
                  name="basic"
                  ref={this.formRefNom}
                  layout="inline"
                  style={{
                    width: "100%",
                    display: "flex",
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onValuesChange={this.onValuesChange}
                  onFinish={this.addNomenclature}
                >
                  <Compact style={{ width: "100%" }}>
                    <Form.Item
                      style={{ width: "10%", marginInlineEnd: 0 }}
                      name="nomenclature"
                    >
                      <NomenclatureAutoComplete
                        buttonIntegrated
                        placeholder={"Выберите товар"}
                        api={this.api}
                        token={this.props.token}
                        onSelect={this.onSelectNom}
                      />
                    </Form.Item>
                    <Form.Item
                      name="name_nomeclature"
                      style={{ width: "90%", marginInlineEnd: 0 }}
                    >
                      <NomenclatureSearchField
                        api={this.api}
                        token={this.props.token}
                        select={this.onSelectNom}
                        nomDS={this.state.nomDS}
                      />
                    </Form.Item>
                  </Compact>

                  <Form.Item name="count" initialValue={1} hidden>
                    <InputNumber precision={0} min={0} />
                  </Form.Item>
                </Form>
              </Header>
              <Content style={contentStyle}>
                <Table
                  style={{ marginTop: 10 }}
                  dataSource={nomDS}
                  components={components}
                  rowClassName={() => "editable-row"}
                  onRow={(i, z) => console.log(i, z)}
                  rowKey={(record) => record.id}
                  bordered
                  columns={columns}
                ></Table>
              </Content>
            </Layout>
            <Sider style={siderStyle}>
              <Form
                name="basic"
                ref={this.finRef}
                layout="vertical"
                style={{ marginLeft: 10, marginRight: 10 }}
              >
                <Form.Item label="Без скидки:" style={{ marginBottom: 12 }}>
                  <Input
                    style={{ color: "black" }}
                    disabled
                    value={this.state.amount_without_discount}
                  />
                </Form.Item>

                <Form.Item label="Скидка:" style={{ marginBottom: 12 }}>
                  <Input
                    style={{ color: "black" }}
                    disabled
                    value={this.state.amount_discount}
                  />
                </Form.Item>

                <Form.Item
                  label="Остаток лояльности:"
                  style={{ marginBottom: 12 }}
                >
                  <Input
                    style={
                      !this.state.loyality_balance
                        ? { color: "orange", borderColor: "orange" }
                        : this.state.loyality_balance === "Нет карты"
                        ? { color: "red", borderColor: "red" }
                        : Number(this.state.loyality_balance) === 0
                        ? { color: "green", borderColor: "green" }
                        : { color: "blue", borderColor: "blue" }
                    }
                    disabled
                    value={
                      !this.state.loyality_balance
                        ? "Не выбран контрагент!"
                        : this.state.loyality_balance === "Нет карты"
                        ? this.state.loyality_balance
                        : Number(this.state.loyality_balance) === 0
                        ? "Нет баллов"
                        : this.state.loyality_balance
                    }
                  />
                  {this.state.loyality_balance === "Нет карты" ? (
                    <Button
                      onClick={this.createLoyalityCard}
                      style={{ width: "100%", marginTop: "10px" }}
                    >
                      Создать карту
                    </Button>
                  ) : null}
                </Form.Item>

                <Form.Item label="Итого:" style={{ marginBottom: 12 }}>
                  <Input
                    style={{ color: "black" }}
                    disabled
                    value={this.state.amount_with_discount}
                  />
                </Form.Item>

                <Form.Item
                  label="Баллами:"
                  name={"lt"}
                  style={{ marginBottom: 12 }}
                >
                  <InputNumber
                    ref={this.inputLoyality}
                    style={{ width: "100%" }}
                    precision={2}
                    min={0}
                    disabled={!this.state.loyality_card}
                    max={this.state.max_paid_loyality}
                    controls={false}
                    onChange={(value) => this.onRecalculateRubles(value)}
                  />
                </Form.Item>

                <Form.Item label="Рублями:" name={"rubles"}>
                  <InputNumber
                    style={{ width: "100%" }}
                    precision={2}
                    min={0}
                    max={this.state.amount_with_discount}
                    controls={false}
                    onChange={(value) => this.onRecalculateLoyality(value)}
                  />
                </Form.Item>
              </Form>

              <Button
                onClick={() => this.finish("add_proc")}
                style={{ width: "100%" }}
                loading={this.state.isRequestLoading}
              >
                Создать и провести
              </Button>
              <Button
                onClick={() => this.finish("only_add")}
                style={{ marginTop: 10, width: "100%" }}
                loading={this.state.isRequestLoading}
              >
                Только создать
              </Button>
            </Sider>
          </Layout>
        </Modal>
      </>
    );
  }
}

export default NewDocsSales;
